import Model from "./model";

export default class Controller {
    constructor() {
        this.model = new Model()
        this.languageSelectDirty = false;
    }

    updateCountry(country) {
        this.model.setAddressCountryCode(country.code)
        this.updateDefaultLanguageCode(country.code)
        this.model.setRegionCode(country.region_code)
    }

    setAddressCountryCode(value) {
        this.model.setAddressCountryCode(value)
    }

    setRegionCode(value) {
        this.model.setRegionCode(value)
    }

    updateDefaultInfo(addressCountryCode, regionCode, name, surname, areaId, avatar, languageCode) {
        if (languageCode) {
            this.model.setLanguageCode(languageCode)
        }

        this.model.setAddressCountryCode(addressCountryCode)
        this.model.setRegionCode(regionCode)
        this.model.setName(name)
        this.model.setSurname(surname)
        this.model.setAreaId(areaId)
        this.model.setAvatar(avatar)
    }

    setLanguageSelectDirty() {
        this.languageSelectDirty = true
    }

    updateDefaultLanguageCode(country) {
        if(this.languageSelectDirty) return
        if(country === 'us') this.setLanguageCode('en_US')
        if(country === 'gb') this.setLanguageCode('en_GB')
    }

    setName(value) {
        this.model.setName(value)
        this.model.validateName()
    }

    setLanguageCode(value) {
        this.model.setLanguageCode(value)
    }

    setCompanyName(value) {
        this.model.setCompanyName(value)
    }

    setCompanyTeamSize(value) {
        this.model.setCompanyTeamSize(value)
    }

    setSurname(value) {
        this.model.setSurname(value)
        this.model.validateSurname()
    }

    setAvatarData(value) {
        this.model.setAvatarData(value)
    }

    setAreaId(value) {
        this.model.setAreaId(value)
    }

    setUseOption(value) {
        this.model.setUseOption(value)
    }

    setNewsLetter(value) {
        this.model.setNewsLetter(value)
    }

    setHearAbout(value) {
        this.model.setHearAbout(value)
    }

    setHearAboutOther(value) {
        this.model.setHearAboutOther(value)
    }

    setOtherSoftware(value) {
        this.model.setOtherSoftware(value)
    }

    toggleSoftwareSelect(software) {
        this.model.toggleSoftwareSelect(software)
    }

    validatePersonForm() {
        this.model.validateForm()
    }

    validateCompanyForm() {
        this.model.validateCompanyForm()
    }

    validateCountryForm() {
        this.model.validateCountryForm()
    }
}